import React from 'react';
import './wordlist.css';
import Searchbar from './searchbar';
import SearchHistory from './searchhistory';

const popularcusine = ['煮卵', '白菜+卵', '鶏むね+レンジ'];
const vegetables = [
  '人参', '玉ねぎ', '大根', 'キャベツ', 'ネギ', 'きゅうり', '白菜', 'トマト', 'ほうれん草', 'レタス',
  'ピーマン', 'パプリカ', 'ごぼう', 'もやし', 'ブロッコリー', 'かぼちゃ', '小松菜', "水菜", 'ニラ', 'おくら',
  'じゃがいも', 'さつまいも', '里芋', 'チンゲン菜', '茄子', 'かぶ', '豆苗', '大豆', 'コーン', 'アスパラガス', 'みょうが', 'しそ', 'しいたけ', 'しめじ', 'えのき', 'エリンギ'
  , 'アボカド', 'にんにく', '生姜', 'タケノコ'
];
const meat = ['牛肉', '豚肉', '鶏肉', 'ひき肉', '牛切り落とし', '牛こまぎれ', '牛モモブロック', '豚切り落とし', '豚こまぎれ', '豚ロース', '豚バラ', '豚ヒレ',
  '鶏もも', '鶏むね', '手羽先', 'ささみ', '牛ひき肉', '豚ひき肉', '鶏ひき肉', '合挽', 'ラム肉', 'ジビエ',
];
const fish = ['あさり', 'カキ', 'わかめ', 'ひじき', '鮭', 'アジ', 'サバ', 'ブリ', 'カレイ', 'マグロ', '鯛', 'タラ', '鰹', 'イカ', 'タコ'];
const protain = ['卵', 'チーズ', '豆腐', '厚揚げ', '油揚げ', 'ハム', 'ベーコン', 'ウインナー', 'ツナ', 'なっとう', 'こんにゃく', 'ちくわ', 'かまぼこ', 'さつま揚げ', 'トマト缶'];
const seasoning = ['醤油', 'めんつゆ', '味噌', 'ポン酢', '酢', '塩こうじ', '七味', '中華だし', '鶏ガラスープ', 'オイスターソース',
  '豆板醤', 'コチュジャン', 'カレー粉', 'コンソメ', 'ホワイトソース', 'トマト缶', 'ケチャップ', 'マヨネーズ', 'デミグラスソース',
];
const fi = ['簡単', '大量消費', '常備菜', '作り置き', '糖質制限', 'ダイエット', 'レンジ', '炊飯器', '節約'];
const cooking = ['サラダ', '煮物', '炒め', '和え', '焼き', '揚げ', '茹で', '蒸し', 'ドレッシング'];

const season = ['りんご', '柚子', '柿', '里芋', 'みょうが', '栗', 'しいたけ', 'こんぶ', '車海老', 'すだち', '新玉ねぎ', '新じゃがいも'];
const western = ['ハンバーグ', 'ステーキ', 'カレー', 'シチュー', 'ハヤシライス', 'オムライス', 'スクランブルエッグ', 'ポトフ', 'ジャーマンポテト', 'トマト煮込み', 'サンドイッチ', 'ホットサンド'];
const japanese = ['だし巻き', '煮卵', '鍋', '味噌汁', '唐揚げ', '天ぷら', '親子丼', '卵とじ', 'おでん', '筑前煮', '豚汁', '肉じゃが', '茶碗蒸し', '巻き寿司', '照り焼き',
  'お好み焼', '炊き込みご飯', '牛丼', '天丼', '天津飯', '和風'
];
const chinese = ['野菜炒め', '味噌野菜炒め', 'チャーハン', '中華スープ', '餃子', 'トマトと卵の炒め物', '回鍋肉', '麻婆豆腐', 'ニラ玉',
  '豚の角煮', '青椒肉絲', '春巻', '小籠包', '酢豚', '油淋鶏', '棒棒鶏', '八宝菜', 'エビチリ',
];
const italian = ['パスタ', 'スパゲティ', 'ナポリタン', 'ピザ', 'ミネストローネ', 'リゾット', 'ラザニア', 'ムニエル', 'カルパッチョ'];
const korean = ['ナムル', 'チジミ', 'ビビンバ', 'キムチ', 'トッポギ', 'サムギョプサル', 'タッカルビ', 'チャプチェ', '韓国風'];
const othercusine = ['インドカレー', 'ナン', 'ボルシチ', 'ガパオライス', 'タコス', 'ブリトー'];
const men = ['うどん', 'そば', 'ラーメン', '焼きそば', 'つけ麺', '冷やし中華', '担々麺'];

const sweets = ['チョコレート', 'クッキー', 'プリン', 'ゼリー', 'ガトーショコラ', '生チョコ', 'トリュフチョコ', 'ケーキ', 'パウンドケーキ', 'チーズケーキ', 'ロールケーキ', 'スフレ', 'タルト', 'パイ',
  'パンケーキ', 'スコーン', 'マフィン', 'スノーボール', 'ドーナツ', 'アイス', 'シャーベット', 'ババロア', 'ムース', 'パンナコッタ', 'コンポート'
  , 'マカロン', 'マドレーヌ', 'クレープ', 'バター', '生クリーム', 'カスタード', 'ミルク', '抹茶', 'シナモン', 'フルーツ', 'イチゴ', 'ブルーベリー', 'バナナ', 'りんご', 'マンゴー',
];
const jsweets = ['和菓子', 'おしるこ', 'まんじゅう', '団子', '白玉', '桜餅', '柏餅', 'おはぎ', '羊羹', '寒天', '甘納豆', 'カステラ', 'かりんとう'];
class Wordlist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      words: [],
      showClearButton: false,
      searchStr: "", // 追加
    };
  }

  handleWordSelected = (word) => {
    if (!word) return;

    this.setState(prevState => ({
      words: [...prevState.words, word],
      showClearButton: true,
    }));
  }

  clearSelection = () => {
    this.setState({
      words: [],
      showClearButton: false,
      searchStr: "", // クリア時に検索文字列もリセット
    });
  }

  setSearchStr = (str) => { // 追加
    this.setState({ searchStr: str });
  }

  handleOptionChange = (event) => {
    this.setState({
      selectedOption: event.target.value
    });
  }


  renderBox(title, words, styleObj = {}) {
    return (
      <div className="box">
        <object className="box-title" style={styleObj}>
          {title}
        </object>
        {words.map((word) => (
          <span
            key={word}
            className="beforeClicked"
            onClick={() => this.handleWordSelected(word)}
          >
            {word}
          </span>
        ))}
      </div>
    );
  }

  render() {
    const { words, selectedOption, showClearButton, searchStr } = this.state;

    return (
      <article className="contents">
        <div
          style={{
            position: 'sticky',
            top: 0,
            width: '100%',
            zIndex: 1000,
          }}
        >
          <Searchbar
            data={words}
            clearSelection={this.clearSelection}
            str={searchStr} // 追加
            setStr={this.setSearchStr} // 追加
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <a href="/AddHome" id="addhome">
            ホーム画面に追加
            <span role="img" aria-label="question mark">
              &#x2754;
            </span>
          </a>
          <a href="#link">
            ↓料理↓
          </a>

        </div>
        <SearchHistory handleWordSelected={this.handleWordSelected} setStr={this.setSearchStr} // 追加
        /> {/* 修正箇所 */}
        {this.renderBox('おすすめ', popularcusine)}
        {this.renderBox('野菜・きのこ', vegetables, { color: '#70b062' })}
        {this.renderBox('お肉', meat, { color: '#E56E72' })}
        {this.renderBox('たんぱく質・加工品', protain, { color: '#f8e133' })}
        {this.renderBox('おさかな・海の幸', fish, { color: '#9acce3' })}
        <hr className="linedashed" />
        {this.renderBox('いろいろ', fi)}
        <hr className="linedashed" id="link" />
        {this.renderBox('作り方', cooking)}
        {this.renderBox('洋風', western)}
        {this.renderBox('和風', japanese)}
        {this.renderBox('中華', chinese)}
        {this.renderBox('イタリアン', italian)}
        {this.renderBox('韓国風', korean)}
        {this.renderBox('外国風', othercusine)}
        {this.renderBox('麺類', men)}
        {this.renderBox('お菓子', sweets)}
        {this.renderBox('和菓子', jsweets)}
        <div id="lstorage"></div>
      </article>
    );
  }
}

export default Wordlist;